import { CATEGORIES } from './registry.js';

// Legenda por CATEGORIA (a cor do grafo codifica o grupo, não o agente) +
// contagem de agentes de cada grupo. Identidade individual = emoji/nome no nó.
export function createLegend(container) {
  function render(registry) {
    const agents = [...registry.byAddress.values()];
    if (!agents.length) {
      container.innerHTML = '';
      return;
    }
    const counts = new Map();
    for (const a of agents) counts.set(a.category, (counts.get(a.category) ?? 0) + 1);

    container.innerHTML = Object.entries(CATEGORIES)
      .filter(([key]) => counts.has(key))
      .map(
        ([key, cat]) => `
          <span class="legend-chip">
            <span class="legend-chip__dot" style="background:${cat.color}"></span>
            ${cat.label} · ${counts.get(key)}
          </span>
        `,
      )
      .join('');
  }
  return { render };
}
